import { render, staticRenderFns } from "./WorkBase.vue?vue&type=template&id=3c924986&"
import script from "./WorkBase.vue?vue&type=script&lang=js&"
export * from "./WorkBase.vue?vue&type=script&lang=js&"
import style0 from "./WorkBase.vue?vue&type=style&index=0&id=3c924986&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports